/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Warning from 'assets/images/warning.svg';
import { downLoadFiles } from 'services/actions/documents_count';
import { DocumentData } from 'store/modules/documents_store/types';

import { Container } from './styles';

interface Download {
  isRepresentant: boolean;
  is_aws: boolean;
  fileUrl: string;
  name: string;
  cnpj: number | null;
  companyId: number | null;
  id: number;
}

interface ModalWarningAdditionalProps {
  setDownloadLoading: React.Dispatch<React.SetStateAction<boolean>>;
  showModalWarningAdditional: boolean;
  setShowModalWarningAdditional: React.Dispatch<React.SetStateAction<boolean>>;
  setSendToEmail: React.Dispatch<React.SetStateAction<boolean>>;
  docsForDownload?: Array<Download>;
  document?: DocumentData | null;
  sendToEmailModal?: boolean;
}

const ModalWarningAdditional = (props: ModalWarningAdditionalProps) => {
  const {
    showModalWarningAdditional,
    setShowModalWarningAdditional,
    setSendToEmail,
    docsForDownload,
    document,
    sendToEmailModal,
    setDownloadLoading,
  } = props;
  const [checked, setChecked] = useState<boolean>(false);

  return (
    <Modal
      show={showModalWarningAdditional}
      className="d-flex align-items-center"
      onHide={() => {
        setShowModalWarningAdditional(false);
      }}
      centered
    >
      <Container>
        <button
          type="button"
          className="close mx-1 my-1"
          onClick={() => {
            setShowModalWarningAdditional(false);
            if (checked) setChecked(false);
          }}
        >
          <span className="text-dark" aria-hidden="true">
            &times;
          </span>
        </button>
        <div className="modal-body">
          <div className="text-center">
            <img className="mr-1 " src={Warning} width="50px" />
          </div>
          <p>Prezado Cliente,</p>
          <p>
            A <strong>Certidão de Distribuição Cível em Geral - SAJ SGC</strong> e a{' '}
            <strong>Certidão de Distribuição de Falências, Concordatas e Recuperações</strong>{' '}
            deverão ser complementadas com a Certidão do sistema eproc, denominada{' '}
            <strong>Comarcas e Turmas Recursais (Primeiro Grau) - Cível</strong>.
          </p>
        </div>
        <div className="modal-footer d-flex justify-content-between">
          <div className="d-flex">
            <input
              type="checkbox"
              name="Ciente"
              id="AvisoDocComplementar"
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
            />
            <label className="my-0 ml-2" htmlFor="AvisoDocComplementar">
              Estou ciente.
            </label>
          </div>

          <button
            type="button"
            className="btn btn-primary"
            data-dismiss="modal"
            disabled={!checked}
            onClick={() => {
              setShowModalWarningAdditional(false);
              setChecked(false);
              if (docsForDownload && !document && !sendToEmailModal) {
                downLoadFiles(docsForDownload, setDownloadLoading);
              } else if (sendToEmailModal && !document) {
                setSendToEmail(true);
              } else {
                window.open(document?.fileUrl, '_blank');
              }
            }}
          >
            Prosseguir
          </button>
        </div>
      </Container>
    </Modal>
  );
};

export default ModalWarningAdditional;
